// Expand all accordeons where there are input fields that are mandatory but are empty.
window.addEventListener('AutoWise.Admin.ModalContentUpdated', (event) => {
    const modal = event.detail.modal;

    if (!(modal instanceof HTMLDialogElement)) {
        throw new Error('Modal is not an instance of HTMLDialogElement');
    }

    openAllInvalidModals(modal);
});

function openAllInvalidModals(doc) {
    for (const mandatoryField of doc.querySelectorAll('input[required], select[required]')) {
        const isValid = mandatoryField.checkValidity();
        const parent = mandatoryField.closest('details');

        if (isValid || !parent) {
            continue;
        }

        if (mandatoryField.value === '' && !parent.open) {
            parent.open = true;
        }
    }
}

openAllInvalidModals(document);
